import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BreadcrumbHeading from '../../components/global/BreadcrumbHeading';
import { Table, message, Modal, Icon, Popconfirm, Divider, Input, Button } from 'antd';
import InputField from '../../components/global/InputField';
import swal from 'sweetalert';
import { Combobox } from 'react-widgets';
import CelaneseAPI from '../../services';
import config, { utils } from '../../config';
import { getCompaniesData } from '../../actions/index';
import './ManageUsers.css';
import Translation from '../../Translation';
const stringSort = (a, b) => {
    if (a < b) { return -1; }
    if (a > b) { return 1; }
    return 0;
}
const guid = () => {
    var bytes = new Uint8Array(12);
    window.crypto.getRandomValues(bytes);
    var hex = Array.prototype.map.call(bytes, function (value) {
        return ('0' + value.toString(16)).slice(-2);
    }).join('');
    return hex + (new Date()).getTime().toString(16);
}
const dateSort = (a, b) => {
    if (new Date(a).getTime() < new Date(b).getTime()) { return -1; }
    if (new Date(a).getTime() > new Date(b).getTime()) { return 1; }
    return 0;
}
/**
 * Class for ManageUsers.
 *
 * @class ManageUsers
 * @extends {React.Component}
 */
class ManageUsers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            isModalVisible: false,
            isLongMessageModalVisible: false,
            rows: [],
            apiData: [],
            messagesList: [],
            longMessageText: '',
            userRole: '',
            userCompany: '',
            userAzureGroup: '',
            userAzureGroupId: '',
            username: null,
            isAdd: true,
            emailAddress: '',
            firstName: '',
            lastName: '',
            password: '',
            cpassword: '',
            userCountry: '',
            errorMessage: null,
            isCreateLoading: false,
            custCompany: '',
            sortedInfo: {
                columnKey: 'lastLogin',
                order: 'descend'
            },
            filteredInfo: {},
            isDuplicateInTowplus: false,
            countryNames: [],
            filteredCountryNames: [],
            azureGroups: [],
            azureGroupsLoaded: false,
            editItem: null,

            showNewUserModal: false,

            userPhoneNumber: '',
            userFunction: '',
            userCompanyError: false
        }
    }

    /**
     * filterDropdown function is for showing dropdown for each column in the tow items table.
     *
     * @param {Object} opts which is object, it will take selected row keys and user confirmation.
     * @memberof TranslationTable
     */
    filterDropdown = (opts) => {
        let that = this;
        return (
            <div className="custom-filter-dropdown">
                <Input
                    ref={ele => that.searchInput = ele}
                    placeholder={utils.getTranslationText('lbl_filter_text', 'Filter text or =,<,>,=>,<=')}
                    value={opts.selectedKeys ? opts.selectedKeys[0] : '' }
                    onChange={e => opts.setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={that.handleSearch(opts.selectedKeys, opts.confirm)}
                />
                <Button type="primary" onClick={that.handleSearch(opts.selectedKeys, opts.confirm)}><Translation labelName="lbl_search" defaultText="Search" /></Button>
                <Button onClick={that.handleReset(opts.clearFilters)}><Translation labelName="lbl_reset" defaultText="Reset" /></Button>
            </div>)
    }
    /**
    * onFilterDropdownVisibleChange function is for toggling the search input visibility.
    * 
    * @param {boolean} visible takes boolean as input
    * @memberof TranslationTable
    */
    onFilterDropdownVisibleChange = (visible) => {
        let that = this;
        if (visible) {
            setTimeout(() => {
                that.searchInput.focus();
            });
        }
    }
    /**
     * tableRender function is for rendering of highlighted text.
     * 
     * @param {string} text which will take string as input
     * @memberof TranslationTable
     */
    tableRender = (text) => {
        const { searchText } = this.state;
        return searchText ? (
            <span>
                {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === searchText.toLowerCase()
                        ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                ))}
            </span>
        ) : text;
    }
    /**
     * handleSearch function is for performing search on the table with selected row keys.
     * @param {array} selectedKeys
     * @param {func} confirmhandler
     * @memberof TranslationTable
     */
     handleSearch = (selectedKeys, confirmhandler) => () => {
        confirmhandler();
        this.setState({ searchText: selectedKeys[0] });
    }

    /**
     * handleReset function is for clearing searched fields on the table.
     * @param {func} clearFilters
     * @memberof TranslationTable
     */
    handleReset = clearFilters => () => {
        clearFilters();
        this.setState({ searchText: '' });
    }

    componentWillMount() {
        this.setState({
            loading: true
        });
        getCompaniesData().then((res) => {
            this.setState({
                apiData: res && res.data ? res.data : []
            });
        }).catch(() => { });
        this.getMessagesList();
        this.getCountryNames();
        this.getAzureGroups();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companiesData) {
            this.setState({
                apiData: nextProps.companiesData
            });
        }
    }
    getCountryNames = (e) => {
        CelaneseAPI.get(config.API.countryNames).then(resp => {
            if (resp && resp.data) {
                this.setState({
                    countryNames: resp.data,
                    filteredCountryNames: resp.data
                });
            }
        });
    }

    getAzureGroups = () => {
        CelaneseAPI.get(config.API.getAzureGroups).then(resp => {
            if (resp && resp.data) {
                this.setState({
                    azureGroups: resp.data
                }, () => {
                    this.getGroupMembers();
                });
            }
        });
        
    }

    getGroupMembers = () => {
        let azureGroups = this.state.azureGroups;
        let promises = [];
        azureGroups.forEach(item => {
            let groupPromise = CelaneseAPI.post(config.API.getAzureGroupMembers, {
                groupId: item.id
            }).then(resp => {
                if (resp && resp.data) {
                    item.members = resp.data;
                }
                return item;
            });

            promises.push(groupPromise);
        });

        Promise.all(promises).then(() => {
            let users = this.state.rows;
            users.forEach(userItem => {
                let groupFound = null;
                this.state.azureGroups.forEach(groupItem => {
                    if (groupItem.members) {
                        groupItem.members.forEach(memberItem => {
                            if (userItem.azureProfile && (userItem.azureProfile.azureId === memberItem.id)) {
                                groupFound = groupItem;
                            }
                        });
                    }
                });
                if (groupFound) {
                    userItem.azureGroup = groupFound.displayName;
                    userItem.azureGroupId = groupFound.id;
                }
            });
            this.setState({
                azureGroups,
                rows: users,
                azureGroupsLoaded: true
            });
        });
    }

    showAddUserModal = (e) => {
        this.setState({ 
            isAdd: true, 
            visibleCompany: true, 
            errorMessage: null,
            custCompany: '',
            username: '',
            password: '',
            firstName: '',
            lastName: '',
            emailAddress: '',
            cpassword: '',
            userRole: 'USER',
            userCompany: '',
            isDuplicateInTowplus: false,

            userAzureGroup: '',
            userAzureGroupId: '',
            editItem: null
        });
    }

    setNewUserModal = () => {
        this.setState({
            showNewUserModal: true,
            userRole: '',
            isAdd: true,
            isCreateLoading: false,
            userFunction: '',
            userPhoneNumber: '',
            userCompanyError: false,
            errorMessage: ''
        });
    }

    isCreateUserFormValid = (userRole) => {
        let inValidCount = 0;
        if(this.state.emailAddress.trim().length === 0) {
            inValidCount += 1;
        }
        if(this.state.firstName.trim().length === 0) {
            inValidCount += 1;
        }
        if(this.state.lastName.trim().length === 0) {
            inValidCount += 1;
        }
        if(this.state.userCompany.trim().length === 0) {
            inValidCount += 1;
            this.setState({
                userCompanyError: true
            });
        }
        if(inValidCount > 0) {
            this.setState({
                errorMessage: 'Please fill the required fields'
            });
            return false;
        }
        return true;
    }
    isCelaneseEmail = (email = '') => {
        return (email || '').trim().toLowerCase().endsWith('@celanese.com');
    }

    isCeUserEmailBlocked = () => {
        const email = (this.state.emailAddress || '').trim().toLowerCase();
        const role = (this.state.userRole || '').toLowerCase();
        return (role === 'ce-user' || role === 'admin') && !email.endsWith('@celanese.com');
    }

    getRoleOptions = (includeSelectPlaceholder = false) => {
        const options = [];
        if (includeSelectPlaceholder) {
            options.push({ value: '', key: 'Select role' });
        }
        if (this.isCelaneseEmail(this.state.emailAddress)) {
            options.push({ value: 'admin', key: 'Admin' });
            options.push({ value: 'ce-user', key: 'CE User' });
        }
        options.push({ value: 'user', key: 'User' });
        return options;
    }

    createNewUser = () => {
        const requestedRole = (this.state.userRole || '').toLowerCase();

        if (requestedRole === 'admin') {
            this.setState({
                isCreateLoading: false,
                errorMessage: 'Admin users cannot be created from this page.'
            });
            return;
        }

        if (this.isCeUserEmailBlocked()) {
            this.setState({
                isCreateLoading: false,
                errorMessage: 'CE users must use a Celanese email address.'
            });
            return;
        }

        if (requestedRole === 'user' && this.isCreateUserFormValid('user')) {
            this.setState({
                isCreateLoading: true
            });
            let formData = {
                
                "emailAddress": this.state.emailAddress,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "password": this.state.password,
                "role": this.state.userRole,
                "company": this.state.userCompany,
                "custCompany": this.state.custCompany,
                "country": this.state.userCountry,
                "forceChangePasswordNextSignIn": true,
                "function": this.state.userFunction,
                "phone": this.state.userPhoneNumber

                // "emailAddress": this.state.emailAddress,
                // "firstName": this.state.firstName,
                // "lastName": this.state.lastName,
                // "password": this.state.password,
                // "role": this.state.userRole,
                // "company": this.state.userCompany,                
                // "country": this.state.userCountry,
                // "forceChangePasswordNextSignIn": true,
                // "function": this.state.userFunction,
                // "phone": this.state.userPhoneNumber
            };
            if (this.state.isDuplicateInTowplus) {
                formData['isDuplicateInTowplus'] = true;
            }

            CelaneseAPI.post(config.API.manageUsers, formData).then((resp) => {
                let isDuplicateInTowplus = false;
                if (resp.error) {
                    let errorToShow = 'Unable to create user, please check your fields';
                    if (resp.error.code) {
                        if (resp.error.code === 'USER_ALREADY_EXISTS') {
                            errorToShow = 'User already exists in Towplus application';
                            isDuplicateInTowplus = true;
                        }
                    }
                    if (resp.error.message) {
                        errorToShow = resp.error.message;
                        if (resp.error.message.indexOf('userPrincipalName already exists') >= 0) {
                            errorToShow = 'User already exists in Azure portal';
                        }
                    }
                    this.setState({
                        isCreateLoading: false,
                        errorMessage: errorToShow,
                        isDuplicateInTowplus
                    });
                } else {
                    this.setState({
                        isCreateLoading: false,
                        showNewUserModal: false
                    });
                    this.getMessagesList();
                    // message.success(utils.getTranslationText('msg_user_created_success', 'User created Successfully'), 2);
                    this.sendEmailInvitation(formData);
                }
            });
        }
        if (requestedRole === 'ce-user') {
            const firstName = (this.state.firstName || '').trim();
            const lastName = (this.state.lastName || '').trim();
            const emailAddress = (this.state.emailAddress || '').trim();
            if (!emailAddress || !firstName || !lastName) {
                this.setState({
                    isCreateLoading: false,
                    errorMessage: 'Please fill the required fields'
                });
                return;
            }
            this.setState({
                isCreateLoading: true
            });
            
            let formData = {
                "emailAddress": emailAddress,
                "firstName": firstName,
                "lastName": lastName,
                "password": this.state.password,
                "role": this.state.userRole,
                "company": 'Celanese',
                "country": this.state.userCountry,
                "forceChangePasswordNextSignIn": true
            };
            if (this.state.isDuplicateInTowplus) {
                formData['isDuplicateInTowplus'] = true;
            }

            CelaneseAPI.post(config.API.manageUsers, formData).then((resp) => {
                let isDuplicateInTowplus = false;
                if (resp.error) {
                    let errorToShow = 'Unable to create user, please check your fields';
                    if (resp.error.code) {
                        if (resp.error.code === 'USER_ALREADY_EXISTS') {
                            errorToShow = 'User already exists in Towplus application';
                            isDuplicateInTowplus = true;
                        }
                    }
                    if (resp.error.message) {
                        errorToShow = resp.error.message;
                        if (resp.error.message.indexOf('userPrincipalName already exists') >= 0) {
                            errorToShow = 'User already exists in Azure portal';
                        }
                    }
                    this.setState({
                        isCreateLoading: false,
                        errorMessage: errorToShow,
                        isDuplicateInTowplus
                    });
                } else {
                    this.setState({
                        isCreateLoading: false,
                        showNewUserModal: false
                    });
                    this.getMessagesList();
                    // message.success(utils.getTranslationText('msg_user_created_success', 'User created Successfully'), 2);
                    const inviteRedirect = process.env.REACT_APP_AZURE_INVITE_REDIRECT_URI || process.env.REACT_APP_AZURE_REDIRECT_URI;
                    let ceLoginUrl = process.env.REACT_APP_AZURE_AUTHORIZE_ENDPOINT;
                    ceLoginUrl += '?p=' + process.env.REACT_APP_AZURE_LOGIN_POLICY;
                    ceLoginUrl += '&client_id=' + process.env.REACT_APP_AZURE_CLIENT_ID;
                    ceLoginUrl += '&nonce=defaultNonce';
                    ceLoginUrl += '&redirect_uri=' + encodeURIComponent(inviteRedirect);
                    ceLoginUrl += '&scope=openid&response_type=id_token&prompt=login';
                    ceLoginUrl += '&correlationid=' + guid();
                    ceLoginUrl += process.env.REACT_APP_ENV || '';
                    formData['ceUserLink'] = ceLoginUrl;
                    this.sendCEInvitation(formData);
                }
            });
        }
    }
    closeNewUserModal = () => {
        this.setState({
            showNewUserModal: false
        });
    }

    showAddCompanyModal = (e, rec) => {
        e && e.preventDefault();
        let userRole = (rec.oktaProfile && rec.oktaProfile.role);
        userRole = (rec.azureProfile && rec.azureProfile.role) || userRole || "user";
        this.setState({
            visibleCompany: true,
            editCompanyData: rec ? rec : '',
            username: rec.username,
            isAdd: false,
            errorMessage: null,
            emailAddress: rec.username,
            firstName: rec.azureProfile && rec.azureProfile.firstName ? rec.azureProfile.firstName : '',
            lastName: rec.azureProfile && rec.azureProfile.lastName ? rec.azureProfile.lastName: '',
            userRole: userRole.toLowerCase(),
            userCompany: rec.azureProfile && rec.azureProfile.company ? rec.azureProfile.company: '',
            filteredCountryNames: this.state.countryNames,
            userCountry: rec.country || '',
            userAzureGroup: rec.azureGroup,
            userAzureGroupId: rec.azureGroupId,
            userPhoneNumber: rec.phone,
            userFunction: rec.function,
            custCompany: rec.company,

            editItem: rec,
            isCreateLoading: false
        });
    }

    /**
     * success function shows a success message when message is created successfully
     * @param {string} msg custom message to be shown
     * @memberof ManageUsers
     */
    success = (msg) => {
        message.success(msg, 2);
    }

    /**
     * error function shows a error message
     * @memberof ManageUsers
     */
    error = () => {
        message.error(utils.getTranslationText('msg_some_issue', 'There was some issue.'), 2);
    }

    cancelAction = () => {
    }

    /**
     * showMessagePreview function shows a preview content wrapper
     * @param {event} e event is passed
     * @param {object} rec manage message row record is passed
     * @memberof ManageUsers
     */
    showMessagePreview = (e, rec) => {
        e.preventDefault();
        const quickPreviewWrapper = document.querySelector('.quick-preview-message');
        const manageUsersTable = document.querySelector('.cmp-manage-messages__table-wrapper');
        if (rec.id && quickPreviewWrapper) {
            if (quickPreviewWrapper.offsetHeight) {
                manageUsersTable.style['height'] = (manageUsersTable.offsetHeight + quickPreviewWrapper.offsetHeight) + 'px';
            }
            quickPreviewWrapper.querySelector('.quick-preview-message-content').innerHTML = rec.subject + (rec.text && rec.text.length ? ` <a href="#" data-long-message-id= ${ rec.id } class="quick-preview-message-readmore" id="showLargeDescription">${utils.getTranslationText('link_read_more','Read More')}</a>` : '');
            quickPreviewWrapper.classList.remove('displayNone');
            document.querySelector('.main').style['padding-top'] = document.querySelector('.celanese-header').offsetHeight + 'px';
            manageUsersTable.style['height'] = (manageUsersTable.offsetHeight - quickPreviewWrapper.offsetHeight) + 'px';
            this.showLongMessageModal();
        }
    }

    /**
     * showLongMessageModal function is for showing long message modal
     * @memberof ManageUsers
     */
    showLongMessageModal = () => {
        const self = this;
        document.getElementById('showLargeDescription').addEventListener('click', (e) => {
            e.preventDefault();
            const messageId = e && e.target ? e.target.getAttribute('data-long-message-id') : null;
            if (messageId) {
                let index = 0;
                const longTextRecord = self.state.messagesList.filter((val, i) => {
                    if (val.id === messageId) {
                        index = i;
                    }
                    return true;
                });
                this.setState({
                    isLongMessageModalVisible: true,
                    longMessageText: longTextRecord.length ? longTextRecord[index].text : ''
                });
            }
        }, false);
    }

    /**
     * confirmDeleteAction function deletes the message created by the admin
     * @param {*} e here e is an event passed
     * @param {object} rec here rec refers to the record of the message being deleted
     * @memberof ManageUsers
     */
    confirmDeleteAction = (e, rec) => {
        e.preventDefault();
        if (rec.id) {
            this.setState({
                loading: true
            });
            CelaneseAPI.delete(config.API.manageUsersById.replace(':id', rec.id)).then(res => {
                if (!res.error) {
                    this.success(utils.getTranslationText('msg_user_dlt_success', 'User deleted Successfully'));
                    this.getMessagesList();
                } else {
                    this.error(utils.getTranslationText('msg_error_occured_dlt_user', 'Error occured while deleting the User'));
                }
                this.setState({
                    loading: false
                });
            }).catch(() => {
                this.error(utils.getTranslationText('msg_error_occured_dlt_user', 'Error occured while deleting the User'));
                this.setState({
                    loading: false
                });
            });
        }
    }

    /**
     * showManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageUsers
     */
    showManageMessageModal = () => {
        this.setState({
            isModalVisible: true
        });
    }

    handleCompanyCancel = () => {
        this.setState({
            visibleCompany: false,
        });
    }

    /**
     * hideManageMessageModal function is for showing a modal which is for creating messages
     * @memberof ManageUsers
     */
    hideManageMessageModal = () => {
        this.setState({
            isModalVisible: false
        });
    }

    /**
     * hideLongMessageModal function is for hiding a modal which is for creating messages
     * @memberof ManageUsers
     */
    hideLongMessageModal = () => {
        this.setState({
            isLongMessageModalVisible: false
        });
    }

    /**
     * getMessagesList function is for getting list of all messages which are entered by the admin
     * @memberof ManageUsers
     */
    getMessagesList = () => {
        this.setState({
            loading: true
        });
        CelaneseAPI.get(config.API.manageUsers).then(resp => {
            this.setState({
                messagesList: resp && resp.data ? resp.data : [],
                loading: false,
                rows: resp && resp.data ? resp.data : []
            });
        });
    }

    onCreateMessageSuccess = () => {
        this.setState({
            isModalVisible: false
        });
        this.getMessagesList();
    }

    sendEmailInvitation = (formData) => {
        if (formData['role'] && (formData['role'].toUpperCase() === 'user'.toUpperCase() || formData['role'].toUpperCase() === 'ce-user'.toUpperCase())) {
            CelaneseAPI.post(config.API.sendInvitation, {
                "to": formData['emailAddress'],
                "firstname": formData['firstName'],
                "lastname": formData['lastName'],
                "loginUrl": window.location.origin,
                "password": formData['password']
            }).then(res => {
            if (res.data && res.data.message) {
                message.warning(
                    utils.getTranslationText(
                        'msg_register_user_send_invite_error',
                        'User created successfully, but we could not send the invitation email. Please try again later.'
                    ),
                    2
                );
            } else {
                message.success(
                    utils.getTranslationText(
                        'msg_register_user_send_invite',
                        'User created successfully and the invitation email sent successfully.'
                    ),
                    2
                );
            }
        });
        }
    }
    sendAzureInvitation = (formData) => {
        if (formData['role'] && (formData['role'].toUpperCase() === 'user'.toUpperCase() || formData['role'].toUpperCase() === 'ce-user'.toUpperCase())) {
            CelaneseAPI.post(config.API.sendAzureInvitation, {
                "to": formData['emailAddress'],
                "firstname": formData['firstName'],
                "lastname": formData['lastName'],
                "loginUrl": window.location.origin,
                "password": formData['password']
            }).then(res => {
            if (res.data && res.data.message) {
                message.warning(
                    utils.getTranslationText(
                        'msg_register_user_send_invite_error',
                        'User created successfully, but we could not send the invitation email. Please try again later.'
                    ),
                    2
                );
            } else {
                message.success(
                    utils.getTranslationText(
                        'msg_register_user_send_invite',
                        'User created successfully and the invitation email sent successfully.'
                    ),
                    2
                );
            }
        });
        }
    }
    sendCEInvitation = (formData) => {
        CelaneseAPI.post(config.API.sendCEInvitation, {
            "to": formData['emailAddress'],
            "firstname": formData['firstName'],
            "lastname": formData['lastName'],
            "loginUrl": window.location.origin,
            "password": formData['password'],
            "ceUserLink": formData['ceUserLink']
        }).then(res => {
            if (res.data && res.data.message) {
                message.warning(
                    utils.getTranslationText(
                        'msg_register_user_send_invite_error',
                        'User created successfully, but we could not send the invitation email. Please try again later.'
                    ),
                    2
                );
            } else {
                message.success(
                    utils.getTranslationText(
                        'msg_register_user_send_invite',
                        'User created successfully and the invitation email sent successfully.'
                    ),
                    2
                );
            }
        });
    }


    updateRoleAndCompany = () => {
        if (this.state.isAdd) {
            this.setState({
                isCreateLoading: true
            });
            
            let formData = {
                
                "emailAddress": this.state.emailAddress,
                "firstName": this.state.firstName,
                "lastName": this.state.lastName,
                "password": this.state.password,
                "role": this.state.userRole,
                "company": this.state.userCompany,
                "country": this.state.userCountry,
                "forceChangePasswordNextSignIn": false,
                "function": this.state.userFunction,
                "phone": this.state.userPhoneNumber
            };
            if (this.state.isDuplicateInTowplus) {
                formData['isDuplicateInTowplus'] = true;
            }
            CelaneseAPI.post(config.API.manageUsers, formData).then((resp) => {
                let isDuplicateInTowplus = false;
                if (resp.error) {
                    let errorToShow = 'Unable to create user, please check your fields';
                    if (resp.error.code) {
                        if (resp.error.code === 'USER_ALREADY_EXISTS') {
                            errorToShow = 'User already exists in Towplus application';
                            isDuplicateInTowplus = true;
                        }
                    }
                    if (resp.error.message) {
                        errorToShow = resp.error.message;
                        if (resp.error.message.indexOf('userPrincipalName already exists') >= 0) {
                            errorToShow = 'User already exists in Azure portal';
                        }
                    }
                    this.setState({
                        isCreateLoading: false,
                        errorMessage: errorToShow,
                        isDuplicateInTowplus
                    });
                } else {
                    this.getMessagesList();
                    // message.success(utils.getTranslationText('msg_user_created_success', 'User created Successfully'), 2);
                    this.sendEmailInvitation(formData);
                    if (resp.data && resp.data.user) {
                        this.setState({
                            editItem: resp.data.user
                        }, () => {
                            this.setState({
                                loading: true
                            });
                            this.updateAzureGroup();
                        });
                    }
                }
            });
        } else {
            if (this.isChanged()) {
                this.setState({
                    visibleCompany: false,
                    loading: true
                });
                CelaneseAPI.post(config.API.updateUserRoleAndCompany, {
                    username: this.state.username,
                    role: this.state.userRole,
                    company: this.state.userCompany,
                    "firstName": this.state.firstName,
                    "lastName": this.state.lastName,
                    "country": this.state.userCountry,
                    "function": this.state.userFunction,
                    "phone": this.state.userPhoneNumber
                }).then(() => {
                    this.getMessagesList();
                    message.success(utils.getTranslationText('msg_user_updated_success', 'User updated Successfully'), 2);
                    this.updateAzureGroup();
                })
            } else {
                this.setState({
                    loading: true
                });
                this.updateAzureGroup();
            }
        }
    }
    updateAzureGroup = () => {
        if (this.state.editItem && this.state.editItem.azureProfile && this.state.editItem.azureProfile.azureId) {
            if (!(this.state.editItem.azureGroupId === this.state.userAzureGroupId)) {
                CelaneseAPI.post(config.API.setAzureGroup, {
                    groupId: this.state.userAzureGroupId,
                    memberId: this.state.editItem.azureProfile.azureId
                }).then(() => {
                    this.getGroupMembers();
                    this.setState({
                        visibleCompany: false,
                        loading: false
                    });
                });
            } else {
                this.setState({
                    visibleCompany: false,
                    loading: false
                });    
            }
        } else {
            this.setState({
                visibleCompany: false,
                loading: false
            });
        }
    }
    isChanged = () => {
        if (this.state.editItem && this.state.editItem.azureProfile) {
            let azureProfile = this.state.editItem.azureProfile;
            if (azureProfile.email === this.state.username) {
                if (azureProfile.firstName === this.state.firstName) {
                    if (azureProfile.lastName === this.state.lastName) {
                        if (azureProfile.role === this.state.userRole) {
                            if (this.state.editItem.country === this.state.userCountry) {
                                if (azureProfile.company === this.state.userCompany) {
                                    if (this.state.editItem.phone === this.state.userPhoneNumber) {
                                        if (this.state.editItem.function === this.state.userFunction) {
                                            return false;
                                        }
                                    }
                                }
                            }
                        }
                    }   
                }
            }
        }
        return true;
    }
    updateUserRole = (e) => {
        if (this.state.showNewUserModal) {
            this.setState({
                userRole: e.target.value,
                userCompany: '',
                emailAddress: '',
                userCountry: ''
            });
        } else {
            let userCompany = this.state.userCompany;
            if (e.target.value && e.target.value.toUpperCase() === 'admin'.toUpperCase() && 
                e.target.value.toUpperCase() === 'ce-user'.toUpperCase()) {
                userCompany = '';
            }
            this.setState({
                userRole: e.target.value,
                userCompany
            });
        }
    }
    updateUserFunction = (e) => {
        this.setState({
            userFunction: e.target.value
        });
    }
    updateUserCompany = (e) => {
        this.setState({
            userCompany: e.target.value,
            userCompanyError: false
        });
    }
    updateAzureRole = (e) => {
        this.setState({
            userAzureGroupId: e.target.value
        });
    }
    downloadFile() {
        swal({
            title: utils.getTranslationText('msg_fetching_user_items','Fetching user items'),
            text: utils.getTranslationText('msg_download_start_in_few_seconds','Download will start in few seconds...'),
            buttons: false
        });
        /**
         * API call for exporting towitems in excel format
         */
        CelaneseAPI.getBlob('/export-users?format=excel').then(resp => {
            if (resp.error) {
                swal({
                    text: resp.error
                });
                return;
            }
            let element = document.getElementById('export-users-link');
            if(document.body.classList.contains('ie11')) {
                window.navigator.msSaveOrOpenBlob(resp, 'user-items-' + new Date().getTime() + '.xlsx');
                swal.close();
            } else {
                element.setAttribute('href', window.URL.createObjectURL(resp));
                element.setAttribute('download', 'user-items-' + new Date().getTime() + '.xlsx');
                setTimeout(() => {
                    element.click();
                    swal.close();
                }, 1000);
            }
        });
    }
    exportFile(e) {
        e.preventDefault();
        if (this.state.rows.length === 0) {
            swal({
                text: utils.getTranslationText('msg_database','Database has zero tow items, Do you want to continue to export with empty tow items?'),
                buttons: [utils.getTranslationText('lbl_no', 'No'), utils.getTranslationText('lbl_yes', 'Yes')]
            }).then((action) => {
                if (action) {
                    this.downloadFile();
                }
            });
        } else {
            this.downloadFile();
        }
    }

    handleChange = (e) => {
        if (e && e.target) {
            this.setState({
                [e.target.name]: e.target.value
            });
        }
    }

    checkUserRole = (e) => {
        if (this.state.isAdd && this.state.showNewUserModal) {
            const role = (this.state.userRole || '').toLowerCase();
            const email = (this.state.emailAddress || '').trim().toLowerCase();
            const showUserCreateWarning = (role === 'ce-user' || role === 'admin') && !email.endsWith('@celanese.com');
            this.setState({
                showUserCreateWarning
            });
        }
    }

    clearFilters = (e) => {
        e.preventDefault();
        this.setState({
            sortedInfo: {
                columnKey: 'lastLogin',
                order: 'descend'
            },
            filteredInfo: {}
        });
    }

    onTableChange = (a, b, c) => {
        this.setState({
            sortedInfo: c,
            filteredInfo: b
        });
    }
    sendInvitationToUser = (e) => {
        e.preventDefault();
        this.setState({
            loading: true
        });
        CelaneseAPI.post(config.API.sendInvitation, {
            "to": this.state.emailAddress,
            "firstname": this.state.firstName,
            "lastname": this.state.lastName,
            "loginUrl": window.location.origin
        }).then(resp => {
            if (resp.data && resp.data.message) {
                message.warning(
                    utils.getTranslationText(
                        'msg_user_send_invite_error',
                        'Unable to send the invitation email. Please try again later.'
                    ),
                    2
                );
            } else {
                message.success(
                    utils.getTranslationText(
                        'msg_user_send_invite',
                        'Invitation email sent successfully.'
                    ),
                    2
                );
            }
            this.setState({
                loading: false,
                visibleCompany: false
            });
        });
    }

    render() {
        let { filteredInfo } = this.state;
        // console.log("filter infor: ", Object.keys(filteredInfo).filter(x => filteredInfo[x]).length);
        this.columns = [{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Email"/>,
            key: 'email',
            sorter: (a, b) => stringSort(a['username'], b['username']),
            align: 'left',
            filteredValue: filteredInfo.email || null,
            sortOrder: this.state.sortedInfo.columnKey === 'email' && this.state.sortedInfo.order,
            render: (rec) => {
                return (<span>{rec.email || rec.username}</span>);
            },
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            onFilter: (value, record) => (record['username'] || "").toString().toLowerCase().includes(value.toLowerCase())
        },{
            title: <Translation labelName="manage_users_tbl_hdr_name" defaultText="Name"/>,
            key: 'name',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.name || null,
            sortOrder: this.state.sortedInfo.columnKey === 'name' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                let aFirstName = (a.oktaProfile && a.oktaProfile.firstName);
                aFirstName = (a.azureProfile && a.azureProfile.firstName) || aFirstName;
                let bFirstName = (b.oktaProfile && b.oktaProfile.firstName);
                bFirstName = (b.azureProfile && b.azureProfile.firstName) || bFirstName;
                // let aLastName = (a.oktaProfile && a.oktaProfile.lastName);
                // aLastName = (a.azureProfile && a.azureProfile.lastName) || aLastName;
                let bLastName = (b.oktaProfile && b.oktaProfile.lastName);
                bLastName = (b.azureProfile && b.azureProfile.lastName) || bLastName;
                return stringSort(aFirstName + ' ' + aFirstName, bFirstName + ' ' + bLastName);
            },
            render: (rec) => {
                let firstName = (rec.oktaProfile && rec.oktaProfile.firstName);
                firstName = (rec.azureProfile && rec.azureProfile.firstName) || firstName;
                let lastName = (rec.oktaProfile && rec.oktaProfile.lastName);
                lastName = (rec.azureProfile && rec.azureProfile.lastName) || lastName;
                return (<span>{firstName + ' ' + lastName}</span>);
            },
            onFilter: (value, rec) => {
                let fvalueToCheck = (rec.oktaProfile && rec.oktaProfile.firstName);
                fvalueToCheck = (rec.azureProfile && rec.azureProfile.firstName) || fvalueToCheck;
                let valueToCheck = (rec.oktaProfile && rec.oktaProfile.lastName);
                valueToCheck = (rec.azureProfile && rec.azureProfile.lastName) || valueToCheck;
                return (fvalueToCheck || "").toString().toLowerCase().includes(value.toLowerCase()) || (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Role"/>,
            key: 'role',
            align: 'left',
            nocustomfilter: true,
            filteredValue: filteredInfo.role || null,
            sortOrder: this.state.sortedInfo.columnKey === 'role' && this.state.sortedInfo.order,
            filters: [
                {
                    text: <Translation labelName="role_lbl_admin" defaultText="Admin" />,
                    value: 'admin',
                },
                {
                    text: <Translation labelName="role_lbl_ce_user" defaultText="CE User" />,
                    value: 'ce-user',
                },
                {
                    text: <Translation labelName="role_lbl_user" defaultText="User" />,
                    value: 'user',
                }
            ],
            onFilter: (value, rec) => {
                let role = (rec.oktaProfile && rec.oktaProfile.role);
                role = (rec.azureProfile && rec.azureProfile.role) || role || "";
                return role.toUpperCase() === value.toUpperCase();
            },
            sorter: (a, b) => {
                let aRole = (a.oktaProfile && a.oktaProfile.role);
                aRole = (a.azureProfile && a.azureProfile.role) || aRole || "";
                let bRole = (b.oktaProfile && b.oktaProfile.role);
                bRole = (b.azureProfile && b.azureProfile.role) || bRole || "";
                return stringSort(aRole, bRole);
            },
            render: (rec) => {
                let role = (rec.oktaProfile && rec.oktaProfile.role);
                role = (rec.azureProfile && rec.azureProfile.role) || role || "";
                
                return (<div>{role}</div>);
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Company"/>,
            key: 'company',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.company || null,
            sortOrder: this.state.sortedInfo.columnKey === 'company' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                let aCompany = (a.oktaProfile && a.oktaProfile.company);
                aCompany = (a.azureProfile && a.azureProfile.company) || aCompany || "";
                let bCompany = (b.oktaProfile && b.oktaProfile.company);
                bCompany = (b.azureProfile && b.azureProfile.company) || bCompany || "";
                return stringSort(aCompany, bCompany);
            },
            render: (rec) => {
                let company = (rec.oktaProfile && rec.oktaProfile.company);
                company = (rec.azureProfile && rec.azureProfile.company) || company || "";
                return (<span>{company}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.oktaProfile && rec.oktaProfile.company);
                valueToCheck = (rec.azureProfile && rec.azureProfile.company) || valueToCheck;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_function" defaultText="Function"/>,
            key: 'function',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.function || null,
            sortOrder: this.state.sortedInfo.columnKey === 'function' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.function, b.function);
            },
            render: (rec) => {
                return (<span>{rec.function}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.function);
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_phone" defaultText="Phone"/>,
            key: 'phone',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.phone || null,
            sortOrder: this.state.sortedInfo.columnKey === 'phone' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.phone, b.phone);
            },
            render: (rec) => {
                return (<span>{rec.phone}</span>);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.phone);
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            }
        },{
            title: <Translation labelName="manage_users_tbl_hdr_country" defaultText="Country"/>,
            key: 'country',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.country || null,
            sortOrder: this.state.sortedInfo.columnKey === 'country' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.country, b.country);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.oktaProfile && rec.oktaProfile.company);
                valueToCheck = (rec.azureProfile && rec.azureProfile.company) || valueToCheck;
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            },
            render: (rec) => {
                if (rec.country) {
                    return (<span>{rec.country}</span>);
                }
                return (<span>-</span>);
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_cust_company" defaultText="Customer Company"/>,
            key: 'custCompany',
            align: 'left',
            filterDropdown: this.filterDropdown,
            onFilterDropdownVisibleChange: this.onFilterDropdownVisibleChange,
            tableRender: this.tableRender,
            filteredValue: filteredInfo.country || null,
            sortOrder: this.state.sortedInfo.columnKey === 'custCompany' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                return stringSort(a.custCompany, b.custCompany);
            },
            onFilter: (value, rec) => {
                let valueToCheck = (rec.custCompany);
                return (valueToCheck || "").toString().toLowerCase().includes(value.toLowerCase());
            },
            render: (rec) => {
                if (rec.custCompany) {
                    return (<span>{rec.custCompany}</span>);
                }
                return (<span>-</span>);
            }
        }, {
            title: <Translation labelName="manage_users_tbl_hdr_email" defaultText="Last Login"/>,
            key: 'lastLogin',
            align: 'left',
            sortOrder: this.state.sortedInfo.columnKey === 'lastLogin' && this.state.sortedInfo.order,
            sorter: (a, b) => {
                let aTime = new Date(1989, 4, 4).getTime();
                let bTime = new Date(1989, 4, 4).getTime();
                if (a.lastLogin && a.lastLogin.length > 0) {
                    aTime = a.lastLogin.indexOf('Z') < 0 ? a.lastLogin - 0 : a.lastLogin;
                }
                if (b.lastLogin && b.lastLogin.length > 0) {
                    bTime = b.lastLogin.indexOf('Z') < 0 ? b.lastLogin - 0 : b.lastLogin;
                }
                return dateSort(aTime, bTime);
            },
            render: (rec) => {
                if (rec.lastLogin && rec.lastLogin.length > 0) {
                    let lastLoginToCheck = rec.lastLogin.indexOf('Z') < 0 ? rec.lastLogin - 0 : rec.lastLogin;
                    let lastLoginDate = new Date(lastLoginToCheck);
                    let timeDiff = window.currentServerTimestamp - lastLoginDate.getTime();
                    let inMinutes = Math.floor(timeDiff / (1000 * 60));
                    let lastLoginTime = 'Just now';
                    if (inMinutes > 1) {
                        lastLoginTime = `${inMinutes} minutes ago`;
                    }
                    if (inMinutes > 60) {
                        let inHours = Math.floor(inMinutes / 60);
                        lastLoginTime = `${inHours} hours ago`;
                        if (inHours >= 24) {
                            let inDays = Math.floor(inHours / 24);
                            lastLoginTime = `${inDays} days ago`;
                            if (inDays > 10) {
                                let lastLoginYear = lastLoginDate.getFullYear();
                                let monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
                                let lastLoginMonth = monthNames[lastLoginDate.getMonth()];
                                let lastLoginDay = lastLoginDate.getDate();
                                lastLoginTime = `${lastLoginMonth} ${lastLoginDay}, ${lastLoginYear}`;
                            }
                        }
                    }
                    return (<span>{ lastLoginTime }</span>);    
                }
                return (<span>-</span>);
            }
        }, {
            title: <Translation labelName="lbl_action" defaultText="Action"/>,
            key: 'action',
            width: 100,
            nocustomfilter: true,
            render: (rec) => (
                <span>
                    <a className="table-links" href="#" onClick={(e) => this.showAddCompanyModal(e, rec)}><Translation labelName="lbl_edit" defaultText="Edit" /></a>
                    <Divider type="vertical" />
                    <Popconfirm title={<Translation labelName="msg_are_sure_want_dlt_usr" defaultText="Are you sure, do you want delete this user?"/>} placement="topRight" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={(e) => this.confirmDeleteAction(e, rec)} onCancel={this.cancelAction} okText={<Translation labelName="lbl_yes" defaultText="Yes"/>} cancelText={<Translation labelName="lbl_no" defaultText="No"/>}>
                        <a className="table-links" href="#"><Translation labelName="btn_delete" defaultText="Delete"/></a>
                    </Popconfirm>
                </span>
            ),
        }];
        let ListItem = ({ item }) => (
            <Fragment>
                {item.name || item.Name}
            </Fragment>
        );
        let adminsCount = this.state.rows.filter(rec => {
            let role = (rec.oktaProfile && rec.oktaProfile.role);
            role = (rec.azureProfile && rec.azureProfile.role) || role || "";
            return role.toLowerCase() === 'admin';
        }).length;
        let ceUsersCount = this.state.rows.filter(rec => {
            let role = (rec.oktaProfile && rec.oktaProfile.role);
            role = (rec.azureProfile && rec.azureProfile.role) || role || "";
            return role.toLowerCase() === 'ce-user';
        }).length;
        let usersCount = this.state.rows.filter(rec => {
            let role = (rec.oktaProfile && rec.oktaProfile.role);
            role = (rec.azureProfile && rec.azureProfile.role) || role || "";
            return !(role.toLowerCase() === 'ce-user' || role.toLowerCase() === 'admin');
        }).length;
        return (
            <Fragment>
                <div className="cmp-manage-messages__header">
                    <BreadcrumbHeading heading={<Translation labelName="title_admin_manage_users" defaultText="Manage Users"/>} />
                    <div className="cmp-manage-messages__header-links">
                        <div className="cmp-manage-messages__header-links-wrapper">
                            {
                                this.state.rows.length ? (
                                    <h4 className="users-length-label"><Translation labelName="lbl_available_user_items" defaultText="User items" />: <strong>{this.state.rows.length}</strong></h4>
                                ) : ''
                            }
                            <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.exportFile(e)}><Translation labelName="btn_export" defaultText="Export" /></button>
                            {/* <button type="button" className="btn btn-default create-user-btn m2-left" onClick={(e) => this.showAddUserModal()}><Translation labelName="btn_create_user" defaultText="Create User" /></button> */}
                            <button type="button" className="btn btn-default create-user-btn m2-left" onClick={(e) => this.setNewUserModal()}><Translation labelName="btn_create_user" defaultText="Create User" /></button>
                        </div>
                        
                        {/* <button
                            type="button"
                            onClick={this.showManageMessageModal}
                            className="btn btn-default create-message-link"><Translation labelName="btn_create_message" defaultText="Create Message"/>
                        </button> */}
                    </div>
                </div>
                <div className="cmp-manage-messages">
                    <div className="cmp-manage-messages__table-wrapper">
                        <div className="m1-bottom table-control-bar">
                            <div>
                                <button type="button" className="btn btn-default export-file-btn" onClick={(e) => this.clearFilters(e)}><Translation labelName="btn_clear_filters" defaultText="Clear Filters" /></button>
                                <button type="button" className="btn btn-default m1-left" onClick={(e) => { this.clearFilters(e);this.getMessagesList(e); }}><Translation labelName="btn_clear_filters_and_reload" defaultText="Refresh Table" /></button>
                            </div>
                            <div className="table-control-bar__right-section">
                                <span className="right-section__item">Admins: { adminsCount }</span>
                                <span className="right-section__item">CE Users: { ceUsersCount }</span>
                                <span className="right-section__item">Users: { usersCount }</span>
                            </div>
                        </div>
                        <Table
                            dataSource={this.state.rows}
                            columns={this.columns}
                            rowKey={Math.random}
                            bordered
                            loading={this.state.loading}
                            pagination={false}
                            onChange={this.onTableChange}
                            scroll={{ y: 'calc(100vh - 300px)' }}
                            size="middle" />
                    </div>
                </div>
                {this.state.visibleCompany &&
                    <Modal
                        className="update-role-company"
                        title={ 
                            this.state.isAdd ? 
                                <Translation labelName="title_create_user" defaultText="Create User"/> : 
                                <Translation labelName="title_update_role_company" defaultText="Update role and company"/>
                            }
                        visible={this.state.visibleCompany}
                        okText={
                            this.state.isAdd ?
                            <Translation labelName="btn_save" defaultText="Submit"/> :
                            <Translation labelName="btn_save" defaultText="Save"/> 
                        }
                        onOk={() => this.updateRoleAndCompany()}
                        onCancel={this.handleCompanyCancel}
                        centered
                        width='750px'
                    >
                        <div>
                            {
                                this.state.errorMessage &&
                                (
                                    <div className="error-text">
                                        {this.state.errorMessage} { this.state.isDuplicateInTowplus && 'Try again to push user to Azure'}
                                    </div>
                                )
                            }
                            {
                                this.state.isAdd && (
                                    <Fragment>
                                        <div>
                                            <InputField
                                                type='text'
                                                label={<Fragment><Translation labelName="lbl_email_address" defaultText="Email address "/>*</Fragment>}
                                                name='emailAddress'
                                                pattern='^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                                                id='emailAddress'
                                                value={this.state.emailAddress}
                                                onChange={(e) => this.handleChange(e)}
                                            />
                                        </div>
                                        
                                    </Fragment>
                                )
                            }
                            <div className="row">
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_firstname" defaultText="Firstname "/>*</Fragment>}
                                        name='firstName'
                                        id='firstName'
                                        value={this.state.firstName}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <InputField
                                        type='text'
                                        label={<Fragment><Translation labelName="lbl_lastname" defaultText="Lastname "/>*</Fragment>}
                                        name='lastName'
                                        id='lastName'
                                        value={this.state.lastName}
                                        onChange={(e) => this.handleChange(e)}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className='col-md-6'>
                                    <label><Translation labelName="lbl_country_label" defaultText="Country" /></label>
                                    <Combobox
                                        caseSensitive={false}
                                        busy={false}
                                        value={this.state.userCountry}
                                        onChange={(name) => {
                                            this.setState({
                                                userCountry: typeof name === 'string' ? name: name.Name,
                                                filteredCountryNames: this.state.countryNames.filter(item => {
                                                    if (name && typeof name === 'string') {
                                                        return item['Name'].indexOf(name) === 0;
                                                    }
                                                    return true;
                                                })
                                            });
                                        }}
                                        data={this.state.filteredCountryNames}
                                        messages={{
                                            emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                        }}
                                        textField='Name'
                                        valueField='Name'
                                        itemComponent={ListItem}
                                    />
                                </div>
                                <div className='col-md-6'>
                                    <div className="user-preference__row">
                                        <label htmlFor="userRole"><Translation labelName="hdr_user_role" defaultText="Role"/></label>
                                        <select value={this.state.userRole ? this.state.userRole : ''} name="userRole" onChange={this.updateUserRole}>
                                            {(
                                                this.getRoleOptions().map((val, i) => {
                                                    return (<option key={i} value={val.value}>{ val.key }</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                </div>
                            </div>

                            {
                                this.state.userRole && this.state.userRole !== 'user' && (
                                    <div className="row m1-bottom">
                                        <div className='col-md-12 field-warning-txt-color'>
                                            Are you sure to set user role as 
                                            {
                                                (this.state.userRole.toUpperCase() === 'CE-USER') ? ' CE User ' : ' Admin '
                                            }
                                            ? please check the email address one more time before 
                                            {
                                                this.state.isAdd ? ' creating ' : ' updating '
                                            }
                                            user.
                                        </div>
                                    </div>
                                )
                                
                            }
                            
                            {
                                this.state.userRole === 'user' && (
                                    <div className="user-preference__row">
                                        <label htmlFor="userCompany"><Translation labelName="lbl_user_company" defaultText="Company Name"/></label>
                                        <select value={this.state.userCompany} name="userCompany" onChange={this.updateUserCompany}>
                                            <Translation labelName="lbl_none" defaultText="None" isOption />
                                            {this.state.apiData && (
                                                this.state.apiData.map((val, i) => {
                                                    return (<option key={i} value={val.company}>{val.company}</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                )
                            }

                            {/* {
                                this.state.userRole !== 'user' && (
                                    <div className="user-preference__row">
                                        <label htmlFor="azureRole"><Translation labelName="lbl_azure_role" defaultText="Azure Group"/></label>
                                        <select value={this.state.userAzureGroupId} name="azureRole" onChange={this.updateAzureRole}>
                                            <Translation labelName="lbl_none" defaultText="None" isOption />
                                            {this.state.azureGroups && (
                                                this.state.azureGroups.map((val, i) => {
                                                    return (<option key={i} value={val.id}>{val.displayName}</option>);
                                                })
                                            )}
                                        </select>
                                    </div>
                                )
                            } */}

                            {
                                this.state.userRole === 'user' && (
                                    <div className='new-user-creation-section'>
                                        <div className='row'>
                                            <div className='col-sm-6'>
                                                <div className='user-preference__row'>
                                                    <label htmlFor="userFunction"><Translation labelName="lbl_function" defaultText="Function"/></label>
                                                    <select className='' value={this.state.userFunction ? this.state.userFunction : ''} name="userFunction" onChange={this.updateUserFunction}>
                                                        <option value="">Select</option>
                                                        <option value="Operations/Quality">Operations/Quality</option>
                                                        <option value="R&amp;D">R&amp;D</option>
                                                        <option value="Procurement">Procurement</option>
                                                        <option value="Business/Sales/Marketing">Business/Sales/Marketing</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className='col-sm-6'>
                                                <InputField
                                                    type='text'
                                                    label={<Fragment><Translation labelName="lbl_user_phone" defaultText="Phone "/></Fragment>}
                                                    name='userPhoneNumber'
                                                    id='userPhoneNumber'
                                                    value={this.state.userPhoneNumber}
                                                    onChange={(e) => this.handleChange(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                        
                            {
                                !this.state.isAdd && (
                                    <div>
                                        <a className="table-links" onClick={this.sendInvitationToUser} href="#" >Send Invitation</a>
                                    </div>
                                )
                            }
                            {
                                this.state.isCreateLoading && <div className="loading-indicator">
                                    <h2 className="loading-indicator-text">
                                        {/* <Icon type="loading" theme="outlined" /> */}
                                        <img alt='loading celanese' src="./images/Celanese_loading.svg" />
                                    <span>Loading</span></h2>
                                </div>
                            }
                        </div>
                    </Modal>}
                    {
                        this.state.showNewUserModal && (
                            <Modal
                            className="update-role-company"
                            title={ <Translation labelName="title_create_user" defaultText="Create User"/> }
                            visible={this.state.showNewUserModal}
                            okText={ <Translation labelName="btn_save" defaultText="Submit"/> }
                            okButtonProps={{
                                disabled: this.isCeUserEmailBlocked()
                            }}
                            onOk={() => this.createNewUser()}
                            onCancel={this.closeNewUserModal}
                            centered
                            width='750px'>
                                <div>
                                    {
                                        this.state.errorMessage &&
                                        (
                                            <div className="error-text">
                                                {this.state.errorMessage}
                                            </div>
                                        )
                                    }
                                    <div className="row">
                                        <div className='col-md-6'>
                                            <div className="user-preference__row">
                                                <label htmlFor="userRole"><Translation labelName="hdr_user_role" defaultText="Role"/></label>
                                                <select value={this.state.userRole ? this.state.userRole : ''} name="userRole" onChange={this.updateUserRole}>
                                                    {(
                                                        [{
                                                            value: "",
                                                            key: "Select role"
                                                        }
                                                        // ,{
                                                        //     value: "admin",
                                                        //     key: "Admin"
                                                        // }
                                                        , {
                                                            value: 'ce-user',
                                                            key: 'CE User'
                                                        }, {
                                                            value: 'user',
                                                            key: 'User'
                                                        }].map((val, i) => {
                                                            return (<option key={i} value={val.value}>{ val.key }</option>);
                                                        })
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {
                                        this.state.userRole && (this.state.userRole.toLowerCase() === 'admin' || this.state.userRole.toLowerCase() === 'ce-user' ) && 
                                         (
                                            <div className='new-user-creation-section'>
                                                {
                                                    this.state.isAdd && (
                                                        <Fragment>
                                                            <div>
                                                                <InputField
                                                                    type='text'
                                                                    label={<Fragment><Translation labelName="lbl_email_address" defaultText="Email address "/>*</Fragment>}
                                                                    name='emailAddress'
                                                                    pattern='^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                                                                    id='emailAddress'
                                                                    value={this.state.emailAddress}
                                                                    onBlur={(e) => this.checkUserRole(e)}
                                                                    onChange={(e) => this.handleChange(e)}
                                                                />
                                                            </div>
                                                            {
                                                                (this.state.userRole.toUpperCase() === 'CE-USER') &&
                                                                (
                                                                    <div className="row m1-bottom">
                                                                        <div className='col-md-12 field-warning-txt-color'>
                                                                            CE users must use a Celanese email address.
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }
                                                        </Fragment>
                                                    )
                                                }
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <InputField
                                                            type='text'
                                                            label={<Fragment><Translation labelName="lbl_firstname" defaultText="Firstname "/>*</Fragment>}
                                                            name='firstName'
                                                            id='ceFirstName'
                                                            value={this.state.firstName}
                                                            onChange={(e) => this.handleChange(e)}
                                                        />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <InputField
                                                            type='text'
                                                            label={<Fragment><Translation labelName="lbl_lastname" defaultText="Lastname "/>*</Fragment>}
                                                            name='lastName'
                                                            id='ceLastName'
                                                            value={this.state.lastName}
                                                            onChange={(e) => this.handleChange(e)}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className='col-md-6'>
                                                        <label><Translation labelName="lbl_country_label" defaultText="Country" /></label>
                                                        <Combobox
                                                            caseSensitive={false}
                                                            busy={false}
                                                            value={this.state.userCountry}
                                                            onChange={(name) => {
                                                                this.setState({
                                                                    userCountry: typeof name === 'string' ? name: name.Name,
                                                                    filteredCountryNames: this.state.countryNames.filter(item => {
                                                                        if (name && typeof name === 'string') {
                                                                            return item['Name'].toLowerCase().indexOf(name.toLowerCase()) === 0;
                                                                        }
                                                                        return true;
                                                                    })
                                                                });
                                                            }}
                                                            data={this.state.filteredCountryNames}
                                                            messages={{
                                                                emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                                            }}
                                                            textField='Name'
                                                            valueField='Name'
                                                            itemComponent={ListItem}
                                                        />
                                                    </div>
                                                </div>           
                                            </div>
                                        )
                                    }
                                    {
                                        this.state.userRole && this.state.userRole.toLowerCase() === 'user' && 
                                        (
                                            <div className='new-user-creation-section'>
                                                {
                                                    this.state.isAdd && (
                                                        <Fragment>
                                                            <div>
                                                                <InputField
                                                                    type='text'
                                                                    label={<Fragment><Translation labelName="lbl_email_address" defaultText="Email address "/>*</Fragment>}
                                                                    name='emailAddress'
                                                                    pattern='^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$'
                                                                    id='emailAddress'
                                                                    value={this.state.emailAddress}
                                                                    onChange={(e) => this.handleChange(e)}
                                                                />
                                                            </div>
                                                            
                                                        </Fragment>
                                                    )
                                                }
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <InputField
                                                            type='text'
                                                            label={<Fragment><Translation labelName="lbl_firstname" defaultText="Firstname "/>*</Fragment>}
                                                            name='firstName'
                                                            id='firstName'
                                                            value={this.state.firstName}
                                                            onChange={(e) => this.handleChange(e)}
                                                        />
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <InputField
                                                            type='text'
                                                            label={<Fragment><Translation labelName="lbl_lastname" defaultText="Lastname "/>*</Fragment>}
                                                            name='lastName'
                                                            id='lastName'
                                                            value={this.state.lastName}
                                                            onChange={(e) => this.handleChange(e)}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className='col-md-6'>
                                                        <label><Translation labelName="lbl_country_label" defaultText="Country" /></label>
                                                        <Combobox
                                                            caseSensitive={false}
                                                            busy={false}
                                                            value={this.state.userCountry}
                                                            onChange={(name) => {
                                                                this.setState({
                                                                    userCountry: typeof name === 'string' ? name: name.Name,
                                                                    filteredCountryNames: this.state.countryNames.filter(item => {
                                                                        if (name && typeof name === 'string') {
                                                                            return item['Name'].toLowerCase().indexOf(name.toLowerCase()) === 0;
                                                                        }
                                                                        return true;
                                                                    })
                                                                });
                                                            }}
                                                            data={this.state.filteredCountryNames}
                                                            messages={{
                                                                emptyList: <Translation labelName="msg_there_r_no_items_list" defaultText="There are no items in this list"/> ,
                                                            }}
                                                            textField='Name'
                                                            valueField='Name'
                                                            itemComponent={ListItem}
                                                        />
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <div className="user-preference__row user-company-field">
                                                            <label htmlFor="userCompany"><Translation labelName="lbl_user_company" defaultText="Company Name"/>*</label>
                                                            <select className={
                                                                this.state.userCompanyError ? 'has-error' : ''
                                                            } required value={this.state.userCompany} name="userCompany" onChange={this.updateUserCompany}>
                                                                <Translation labelName="lbl_none" defaultText="None" isOption />
                                                                {this.state.apiData && (
                                                                    this.state.apiData.map((val, i) => {
                                                                        return (<option key={i} value={val.company}>{val.company}</option>);
                                                                    })
                                                                )}
                                                            </select>
                                                            
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        this.state.userRole && this.state.userRole.toLowerCase() === 'user' && 
                                        (
                                            <div className='new-user-creation-section'>
                                                <div className='row'>
                                                    <div className='col-sm-6'>
                                                        <div className='user-preference__row'>
                                                            <label htmlFor="userFunction"><Translation labelName="lbl_function" defaultText="Function"/></label>
                                                            <select className='' value={this.state.userFunction ? this.state.userFunction : ''} name="userFunction" onChange={this.updateUserFunction}>
                                                                <option value="">Select</option>
                                                                <option value="Operations/Quality">Operations/Quality</option>
                                                                <option value="R&amp;D">R&amp;D</option>
                                                                <option value="Procurement">Procurement</option>
                                                                <option value="Business/Sales/Marketing">Business/Sales/Marketing</option>
                                                                <option value="Other">Other</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className='col-sm-6'>
                                                        <InputField
                                                            type='text'
                                                            label={<Fragment><Translation labelName="lbl_user_phone" defaultText="Phone "/></Fragment>}
                                                            name='userPhoneNumber'
                                                            id='userPhoneNumber'
                                                            value={this.state.userPhoneNumber}
                                                            onChange={(e) => this.handleChange(e)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                    {
                                        this.state.isCreateLoading && <div className="loading-indicator">
                                            <h2 className="loading-indicator-text">
                                                {/* <Icon type="loading" theme="outlined" /> */}
                                                <img alt='loading celanese' src="./images/Celanese_loading.svg" />
                                            <span>Loading</span></h2>
                                        </div>
                                    }
                                </div>
                            </Modal>
                        )
                    }
                <a href="" className="export-users-hidden" id="export-users-link" download=""></a>
            </Fragment>
        );
    }
}

const mapStateToProps = ({ loggedUserState }) => ({
    prefData: loggedUserState.prefData
});

const mapDispatchToProps = dispatch => ({
    getCompaniesData: (data) => dispatch(getCompaniesData(data))
})

export default connect(mapStateToProps, mapDispatchToProps)(ManageUsers);

ManageUsers.propTypes = {
    prefData: PropTypes.object,
    companiesData: PropTypes.any,
    getCompaniesData: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/containers/ManageUsers/index.js